var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45034 2.81548C9.45109 1.99695 7.78205 1.33398 5.72554 1.33398C3.66904 1.33398 2.00149 1.9977 2 2.81548M2 2.81548C2 3.63401 3.66755 4.29698 5.72554 4.29698C7.78354 4.29698 9.45109 3.63401 9.45109 2.81548L9.45109 8.56364M2 2.81548V11.7044C2.00075 12.5229 3.6683 13.1859 5.72555 13.1859C6.72325 13.1859 7.62408 13.0281 8.29245 12.7741M2.00075 5.77846C2.00075 6.59699 3.6683 7.25996 5.72629 7.25996C7.78428 7.25996 9.45184 6.59699 9.45184 5.77846M8.33715 9.79707C7.66506 10.06 6.74336 10.223 5.72555 10.223C3.6683 10.223 2.00075 9.56003 2.00075 8.7415M13.6848 8.97707C14.994 10.2786 14.994 12.3897 13.6848 13.6912C12.3756 14.9927 10.2521 14.9927 8.94293 13.6912C7.63377 12.3897 7.63377 10.2786 8.94293 8.97707C10.2521 7.67558 12.3756 7.67558 13.6848 8.97707Z",
    stroke: "#717680",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinStack);
export default __webpack_public_path__ + "static/media/coin-stack.312364e432049a5328a802a5fe183d4d.svg";
export { ForwardRef as ReactComponent };